import { useTypedQuery } from 'utils/hooks/useTypedQuery';
import { useCallback } from 'react';
import { RsiData, RsiRowOnErrorCallback, RsiRowValidator } from '../../../Types';
import { ValidateImporterEngagementTableDocument } from '../../../validations/data/__generated__/ValidateImporterEngagementTable.graphql';
import { isInvalidField, sanitizeRsiArrayData, sanitizeRsiData } from '../../../validations/impl/validationUtils';
import { useImportersIntl } from '../../../translations/useImportersIntl';

export function useValidateRowAgainstRetroactiveEngagementChange(): RsiRowValidator {
  const api = useValidateEngagementTableApi();
  const { invalidField } = useImportersIntl();
  return useCallback(
    async (row: RsiData, addError: RsiRowOnErrorCallback, table: RsiData[]) => {
      const response = await api.get({
        variables: {
          input: {
            values: [
              {
                index: table.findIndex((it) => it.__index === row.__index),
                urnToValueMap: sanitizeRsiData(row),
                urnToValuesMap: sanitizeRsiArrayData(row)
              }
            ]
          }
        }
      });
      response.data?.result.validations?.forEach((item) => {
        if (isInvalidField(item)) {
          addError(item.urn, { level: 'error', message: item.result.message ?? invalidField });
        }
      });
    },
    [api, invalidField]
  );
}

export function useValidateEngagementTableApi() {
  return useTypedQuery(ValidateImporterEngagementTableDocument);
}
